import ClientPassengerToBeDeletedInterface from '../../interfaces/client/PassengerToBeDeleted'

export const SET_PASSENGERS_TO_BE_DELETED = 'SET_PASSENGERS_TO_BE_DELETED'

export default (passengers: ClientPassengerToBeDeletedInterface[]) => ({
  type: SET_PASSENGERS_TO_BE_DELETED,
  passengers,
})
